import React from "react";
import "app/views/sessions/style_new.css";

function CheckIcon({ icon: Icon, classIs }) {
  if (typeof Icon == "function") {
    return (
      <>
        <Icon className={classIs} />
        &nbsp;
      </>
    );
  } else {
    return <i className={`nav-icon ${Icon}`}></i>;
  }
}
export default CheckIcon;
